export default {
  modal: 1,
  popover: 2,
  tooltip: 3,
}
